import React from 'react';

const RawEditor = ({ erdState, resizing, onSaveEvent }) => {

  const handleLoadSample = () => {
    erdState.loadSampleERD();
    if (onSaveEvent) {
      onSaveEvent('sample_loaded');  // ADD THIS
    }
  };

  return (
    <div className="space-y-4">
      {/* Editor Tips */}
      <div className="bg-blue-50 border border-blue-200 rounded-md p-3 flex-shrink-0">
        <h3 className="font-medium text-blue-800 mb-2">Editor Tips:</h3>
        <ul className="text-sm text-blue-700 space-y-1">
          <li>• Use the Visual Editor tab for easier diagram creation</li>
          <li>• The ERD parser is case-sensitive</li>
          <li>• Use underscore `_` instead of spaces in names</li>
          <li>• Select a relationship to view specific parts</li>
        </ul>
      </div>

      {/* Text Editor */}
      <div className="relative">
        <textarea
          value={erdState.inputText}
          onChange={(e) => {
            const newValue = e.target.value;
            erdState.setInputText(newValue);
            if (onSaveEvent) {
              onSaveEvent('raw_notation_edited', { inputText: newValue });  // ✅ Pass updated text directly
            }
          }}
          placeholder="Enter your ERD notation here..."
          className="w-full border border-gray-300 rounded-md p-4 font-mono text-sm resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          style={{ height: `${erdState.textareaHeight}px` }}
        />
        {/* Vertical Resize Handle */}
        <div
          className="absolute bottom-0 left-0 right-0 h-2 bg-gray-300 hover:bg-gray-400 active:bg-gray-500 cursor-row-resize flex items-center justify-center transition-colors duration-200 group rounded-b-md"
          onMouseDown={resizing.handleVerticalResizeStart}
        >
          <div className="h-1 w-16 bg-gray-500 rounded-full group-hover:bg-gray-600 transition-colors duration-200"></div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex gap-2 flex-wrap flex-shrink-0 mb-4">
        <button
          onClick={handleLoadSample}
          className="bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded-md transition-colors duration-200"
        >
          Load Sample
        </button>
        <button
          onClick={erdState.downloadNotation}
          className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md transition-colors duration-200"
        >
          Download
        </button>
      </div>
    </div>
  );
};

export default RawEditor;